import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./locales/ru/translation";
import uk from "./locales/uk/translation";
import en from "./locales/en/translation";

const savedLanguage = localStorage.getItem("i18nextLng");
const defaultLanguage = savedLanguage || "uk";

i18n.use(initReactI18next).init({
	resources: {
		ru: {
			translation: ru,
		},
		uk: {
			translation: uk,
		},
		en: {
			translation: en,
		},
	},
	lng: defaultLanguage,
	fallbackLng: "uk",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
